import { Button } from "@msuite/ui/button";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { Tabs } from "@msuite/ui/tabs";
import { TicketFiles } from "@/components/tickets/ticket-files";
import { TicketGeneral } from "@/components/tickets/ticket-general";
import { TicketTimeline } from "@/components/tickets/ticket-timeline";

/** Props Interface */
interface TicketInformationModalProps extends ModalProps {
	ticketId: string;
	projectId: string;
}

export function TicketInformationModal({
	isOpen,
	onClose,
	ticketId,
	projectId,
}: TicketInformationModalProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	return (
		<Modal
			isOpen={isOpen}
			onClose={onClose}
			title={t("general.information")}
			width="700px"
		>
			<Modal.Body>
				<Tabs
					groups={[
						{
							name: "general",
							panels: [
								{
									label: t("general.general"),
									panel: () => <TicketGeneral ticketId={ticketId} />,
									errors: [],
									cyId: "ticket-general-tab",
								},
								{
									label: t("timeline.timeline"),
									panel: () => <TicketTimeline ticketId={ticketId} />,
									errors: [],
									cyId: "ticket-timeline-tab",
								},
								{
									label: t("files.files"),
									panel: () => (
										<TicketFiles
											ticketId={ticketId}
											projectId={projectId}
										/>
									),
									errors: [],
									cyId: "ticket-files-tab",
								},
							],
						},
					]}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onClose}>{t("general.close")}</Button>
			</Modal.Footer>
		</Modal>
	);
}
